__turbopack_context__.v({
  "body": "ParagraphTimelineSteps-module__I0PBlG__body",
  "duration": "ParagraphTimelineSteps-module__I0PBlG__duration",
  "eyebrow": "ParagraphTimelineSteps-module__I0PBlG__eyebrow",
  "header": "ParagraphTimelineSteps-module__I0PBlG__header",
  "lead": "ParagraphTimelineSteps-module__I0PBlG__lead",
  "list": "ParagraphTimelineSteps-module__I0PBlG__list",
  "num": "ParagraphTimelineSteps-module__I0PBlG__num",
  "section": "ParagraphTimelineSteps-module__I0PBlG__section",
  "step": "ParagraphTimelineSteps-module__I0PBlG__step",
  "stepDesc": "ParagraphTimelineSteps-module__I0PBlG__stepDesc",
  "stepName": "ParagraphTimelineSteps-module__I0PBlG__stepName",
  "title": "ParagraphTimelineSteps-module__I0PBlG__title",
});
